/*
 * Starling service used to call for starling data
 * Follow endpoint from https://developer.starlingbank.com/docs (Scroll down below Help & Support)
 */

import axios from 'axios'
import store from '@/state/store'

const authService = axios.create({
  baseURL: process.env.VUE_APP_AUTH_SERVICE_URL + 'api/',
})

authService.interceptors.request.use(async (config) => {
  if (!store.getters['user/token']) return config

  const token = await store.getters['user/token']
  config.headers.common.Authorization = 'Bearer ' + token

  return config
})

export default authService
